'use client'

// src/api/queries/deal.ts
var DEAL_QUERY = `
id
label
labelPrefix
price
endsAt
featured
`;

export {
  DEAL_QUERY
};
//# sourceMappingURL=chunk-SP6R2NC7.mjs.map